import { Box, Typography } from "@mui/material"
import { useNavigate, useSearchParams } from "react-router-dom"
import useAppStore from "store/app"
import useAlertStore from "store/alert"

import Layout from "./Layout"
import SecondaryButton from "../../shared/buttons/SecondaryButton"
import BackButton from "components/shared/buttons/BackButton"
import EmailConfirmationCode from "components/shared/fields/EmailConfirmationCode"
import useTranslation from "../../../hooks/use_translation"

const EmailConfirmation = () => {
  const fields = useAppStore((state) => state.fields)
  const updateFieldErrorMessage = useAppStore((state) => state.updateFieldErrorMessage)
  const confirmEmail = useAppStore((state) => state.confirmEmail)
  // const confirmResetPasswordEmail = useAppStore((state) => state.confirmResetPasswordEmail)
  const showAlert = useAlertStore((state) => state.showAlert)

  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const action = searchParams.get("action")

  const { pages, messages } = useTranslation()

  const handleSubmit = (e) => {
    e.preventDefault()

    const errorsCheck = ["email_confirmation_code"]

    errorsCheck.map((field) => {
      if (!fields[field]?.touched) {
        updateFieldErrorMessage(field, "This field is required")
      }
    })

    const valid = errorsCheck.every((field) => fields[field].error_message === "")

    if (!valid) return

    const params = {
      email: fields.email.input_value,
      confirm_code: fields.email_confirmation_code.input_value,
    }

    confirmEmail(params)
      .then((response) => {
        localStorage.setItem("token", response.data.access_token)

        if (action === "create") {
          navigate("/me/personal_data/physiological")
        } else if (action === "reset") {
          navigate("/me/personal_data/password")
        } else {
          showAlert(messages?.technical_error, "error")
        }
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error_messages, "error")
      })
  }

  return (
    <Layout>
      <BackButton />
      <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>
        {pages?.email_confirmation?.enter_digits}
      </Typography>
      <Typography variant="body1" component="span">
        {pages?.email_confirmation?.email_verify} {fields.email.input_value}
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <EmailConfirmationCode />
        <SecondaryButton text={pages?.reset_password?.submit_btn} fullWidth type="submit" />
      </Box>
    </Layout>
  )
}

export default EmailConfirmation
